;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _vueSelect = require("vue-select");

var _vueSelect2 = _interopRequireDefault(_vueSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component("v-select", _vueSelect2.default);
exports.default = {
  data: function data() {
    return {
      file: null,
      banks: [],
      selectedBank: null,
      owner_type: "merchant",
      bank_account_name: null,
      cancelled_cheque: null,
      bank_account_name_error: null,
      branch_error: null,
      branch: null,
      bank_account_number_error: null,
      bank_account_number: null,
      owner_id: null,
      consumer_secret: null,
      consumer_key: null,
      api_token: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.getOauthToken();
    $("#addBankAccountModal").on("hidden.bs.modal", function () {
      _this.reset();
    });
  },
  created: function created() {
    this.owner_id = this.$attrs["merchant_id"];
  },
  methods: {
    getOauthToken: function getOauthToken() {
      var _this2 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.api_token = response.data.token;
        _this2.banks = _this2.loadBanks();
      }).catch(function (error) {}).then(function () {});
    },
    reset: function reset() {
      this.bank_account_name = null;
      this.bank_account_number = null;
      this.branch = null;
    },
    loadBanks: function loadBanks() {
      var _this3 = this;

      var url = "/api/banks";
      var api_headers = { Authorization: "Bearer " + this.api_token };
      Vue.axios.get(url, {
        headers: api_headers
      }).then(function (response) {
        _this3.banks = response.data.banks;
      }).catch(function (error) {}).then(function () {});
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    validateBankAccount: function validateBankAccount() {
      if (this.selectedBank && this.bank_account_number && this.branch && this.bank_account_name) {
        this.createBankAccount();
      }
      _sweetalert2.default.fire({
        icon: "error",
        title: "Oops...",
        text: "Complete the form to create a bank account !"
      });
    },
    createBankAccount: function createBankAccount() {
      var urlIs = "/api/banks/accounts/create/custom";
      var api_headers = {
        Authorization: "Bearer " + this.api_token
      };
      var formData = new FormData();
      formData.append("file", this.file);

      var api_params = {
        bank_id: this.selectedBank.id,
        account_number: this.bank_account_number,
        branch: this.branch,
        name: this.bank_account_name,
        owner_id: this.owner_id,
        owner_type: this.owner_type
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Ensure the Bank Account is not already created"
          });
        } else {
          $("#addBankAccountModal .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Bank Account has been created",
            showConfirmButton: false,
            timer: 2500
          });
          window.location.href = window.location.pathname;
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('a',{staticClass:"btn btn-primary lift",attrs:{"href":"#","data-toggle":"modal","data-target":"#addBankAccountModal"}},[_vm._v("Add Bank Account")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"addBankAccountModal","tabindex":"-1","role":"dialog","aria-labelledby":"addBankAccountModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"id":"frmaddBankAccountModal","name":"frmaddBankAccountModal","onsubmit":"return false;"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"inp_account_name"}},[_vm._v("Bank")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.banks,"reduce":function (name) { return name.id; }},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Branch")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.branch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.branch=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"inp_account_name"}},[_vm._v("Bank Account Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank_account_name),expression:"bank_account_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bank_account_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bank_account_name=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Account Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank_account_number),expression:"bank_account_number"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bank_account_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bank_account_number=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Submit"},on:{"click":_vm.validateBankAccount}})])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Add Bank Account")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a03d9b96", __vue__options__)
  } else {
    hotAPI.reload("data-v-a03d9b96", __vue__options__)
  }
})()}